// ⚙️ VISUAL CUSTOMIZATION - Edit colors, fonts, and animations here

export const theme = {
  // Brand Colors - BLACK & GOLD LUXURY THEME
  colors: {
    primary: '#D4AF37',        // Gold - buttons, links
    primaryHover: '#F4C430',   // Bright gold hover
    primaryActive: '#B8950A',  // Dark gold active

    success: '#52c41a',        // Green - success states
    warning: '#FFD700',        // Gold warning
    error: '#ff4d4f',          // Red - errors
    info: '#D4AF37',           // Gold - info messages

    // Backgrounds
    bgPrimary: '#1a1a1a',      // Dark black background
    bgSecondary: '#0f0f0f',    // Darker black
    bgDark: '#000000',         // Pure black header/sidebar
    bgCard: '#2a2a2a',         // Card background

    // Text
    textPrimary: '#ffffff',    // White main text
    textSecondary: '#D4AF37',  // Gold secondary text
    textLight: '#999999',      // Gray light text
    textWhite: '#ffffff',      // White text
    textGold: '#D4AF37',       // Gold accent text

    // Borders
    border: '#404040',
    borderLight: '#2a2a2a',
    borderGold: '#D4AF37',

    // Impact colors for document comparison
    impactHigh: '#ff4d4f',
    impactMedium: '#FFD700',
    impactLow: '#52c41a'
  },

  // Typography - Font settings
  fonts: {
    primary: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    mono: '"Courier New", Courier, monospace'
  },

  // Spacing - Consistent spacing values
  spacing: {
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px'
  },

  // Border Radius
  radius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    round: '50%'
  },

  // Shadows
  shadows: {
    sm: '0 1px 2px rgba(0, 0, 0, 0.03)',
    md: '0 4px 12px rgba(0, 0, 0, 0.08)',
    lg: '0 8px 24px rgba(0, 0, 0, 0.12)',
    xl: '0 12px 40px rgba(0, 0, 0, 0.16)'
  },

  // Animation Durations - Change speed of animations
  animation: {
    fast: '0.15s',
    normal: '0.3s',
    slow: '0.5s',
    verySlow: '0.8s'
  },

  // Transitions - Easing functions
  easing: {
    standard: 'cubic-bezier(0.4, 0.0, 0.2, 1)',
    decelerate: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
    accelerate: 'cubic-bezier(0.4, 0.0, 1, 1)',
    sharp: 'cubic-bezier(0.4, 0.0, 0.6, 1)'
  }
};

// Ant Design theme config - BLACK & GOLD
export const antdTheme = {
  token: {
    colorPrimary: theme.colors.primary,
    colorSuccess: theme.colors.success,
    colorWarning: theme.colors.warning,
    colorError: theme.colors.error,
    colorInfo: theme.colors.info,
    fontFamily: theme.fonts.primary,
    borderRadius: 8,
    fontSize: 14,
    colorBgContainer: theme.colors.bgCard,
    colorBgElevated: theme.colors.bgCard,
    colorBorder: theme.colors.border,
    colorText: theme.colors.textPrimary,
    colorTextSecondary: theme.colors.textLight
  },
  algorithm: 'dark' // Enable dark mode
};
